// Blog.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./Blog.css";
import B1 from "../assets/Blogimg1.jpg"
import B2 from "../assets/Blogimg2.jpg"

const Blog = () => {
  const blogs = [
    {
      title: "Top 5 IT Certifications That Can Boost Your Career in 2025",
      date: "25 July, 2025",
      author: "Admin",
      image:
        B1,
      excerpt:
        "Discover the most valuable IT certifications that can accelerate your career growth in the tech industry.",
      link: "/blog-post", // ✅ First blog route
    },
    {
      title:
        "Preparing for IT Interviews: Common Questions and How to Answer Them",
      date: "05 Aug, 2025",
      author: "Admin",
      image:
        B2,
      excerpt:
        "Master your IT interviews with our comprehensive guide to the most common questions and expert answers.",
      link: "/blog-post2", // ✅ Second blog route
    },
  ];

  return (
    <section id="blog" className="blog">
      <div className="blog-container">
        <div className="blog-header">
          <span className="blog-subtitle animate-fade-in-up">
            Upcoming Events
          </span>
          <h2 className="blog-title animate-fade-in-up animate-delay-100">
            Join Our Community And Make it Bigger
          </h2>
          {/* <a
            href="#all-events"
            className="blog-view-all animate-fade-in-up animate-delay-200"
          >
            See All Events
            <i className="fa-solid fa-arrow-right"></i>
          </a> */}
        </div>

        <div className="blog-grid">
          {blogs.map((blog, index) => (
            <div
              key={index}
              className={`blog-card animate-fade-in-up animate-delay-${
                (index % 2) + 2
              }00`}
            >
              <div className="blog-image-wrapper">
                <img
                  src={blog.image}
                  alt={blog.title}
                  className="blog-image"
                />
              </div>

              <div className="blog-content">
                <div className="blog-meta">
                  <div className="blog-meta-item">
                    <i className="fa-regular fa-calendar"></i>
                    <span>{blog.date}</span>
                  </div>
                  <div className="blog-meta-item">
                    <i className="fa-solid fa-user"></i>
                    <span>by {blog.author}</span>
                  </div>
                </div>

                <h3 className="blog-card-title">{blog.title}</h3>
                <p className="blog-excerpt">{blog.excerpt}</p>

                {/* ✅ Dynamic route based on blog.link */}
                <Link to={blog.link} className="blog-read-more">
                  Read More <i className="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Blog;
